<template>
  <div id="findAddr" class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0"></span>
    <div class="popup">
      <div class="popContain">
        <div class="popCont full" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">주소검색</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="searchWrap address">
                  <div class="iptWrap">
                    <input
                      type="text"
                      id="ipt1_1"
                      class="ipt uiAct"
                      placeholder="예) 디지털로 30/ 논현동/ 신정동 12"
                      title="주소 검색어 입력"
                      value=""
                      v-model="inAdm"
                    />
                    <button class="btnIco_del" tabindex="-1">
                      <span class="blind">해당 필드 입력값 삭제</span>
                    </button>
                  </div>
                  <button type="button" class="btnIco_srch" @click="searchAddr">
                    <span>검색</span>
                  </button>
                </div>
              </section>

              <!-- 주소검색 초기화면(s) -->
              <section v-if="searchResult == null">
                <p class="txtM">
                  지번주소(동/읍/면/리),
                  <br />
                  도로명 또는 건물명(아파트)를 입력해주세요.
                </p>

                <div class="boxMsg searchInfo">
                  <p class="pointC4">주소검색이 안된다면 아래와 같이 입력해보세요.</p>
                  <ul class="txtList_square">
                    <li>
                      <span class="pointC5">도로명 + 건물명</span>
                      <br />
                      예) 디지털로 300, 상암산로 1길 24
                    </li>
                    <li>
                      <span class="pointC5">건물명</span>
                      <br />
                      예) 판교세븐벤처벨리1
                    </li>
                    <li>
                      <span class="pointC5">동/읍/면/리 + 번지</span>
                      <br />
                      예) 삼평동 625
                    </li>
                  </ul>
                </div>
              </section>

              <section v-else>
                <div class="resultMsg fail" v-if="searchResultLength < 1">
                  <p class="copy">검색결과가 없습니다.</p>
                </div>

                <div class="resultMsg error" v-else-if="searchResultLength >= 100">
                  <p class="copy">검색결과가 너무 많습니다.</p>
                  <p class="desc">
                    찾으시려는 주소의 건물번호 또는 건물명까지
                    <br />
                    상세히 입력하여 검색해주세요.
                  </p>
                </div>

                <ul class="addressList" v-else>
                  <li v-for="(result, index) in searchResult" :key="index">
                    <a @click="selectAddr(index)">
                      <div class="address">
                        <p>
                          <span class="pointC5">[도로명]</span>
                          <span>
                            {{ result.NADR1 }}&nbsp;{{ result.NADR3 }}

                            <span v-if="result.BLD != undefined && result.BLD != '' && result.BLD.length > 0">({{ result.BLD }})</span>
                          </span>
                        </p>
                        <p>
                          <span class="pointC5">[지번]</span>
                          <span>{{ result.ADR1 }}&nbsp;{{ result.BUNJI }}</span>
                        </p>
                      </div>
                      <span class="zipcode">
                        <span class="blind">우편번호</span>
                        <span v-text="result.ZIP"></span>
                      </span>
                    </a>
                  </li>
                </ul>
              </section>
              <!-- 주소검색 초기화면(e) -->

              <!-- 본문 (e) -->
            </div>
          </div>

          <!-- <div class="btnArea sticky">
            <button type="button" class="btn_p">수정완료</button>
          </div> -->

          <button type="button" class="btnIco_close" @click="$emit('close')">
            <span>팝업 닫기</span>
          </button>
        </div>
      </div>
    </div>
    <span class="blind focusSet last" tabindex="0"></span>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';

export default {
  data() {
    return {
      inAdm: null,
      searchResult: null,
      searchResultLength: null,
    };
  },
  methods: {
    popupClose() {
      this.inAdm = null;
      this.searchResult = null;
      this.searchResultLength = null;
      this.$emit('close');
    },
    searchAddr() {
      ApiService.service('GET', '/common/address/select?inAdm=' + this.inAdm)
        .then(({ data }) => {
          console.log(data);
          var resultCode = data.isSucceed;

          if (resultCode) {
            this.searchResult = data.result;
            this.searchResultLength = data.result.length;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    selectAddr(index) {
      var zip = this.searchResult[index].ZIP;
      var nadr1 = this.searchResult[index].NADR1;
      var nadr3 = this.searchResult[index].NADR3;
      var bld = this.searchResult[index].BLD;
      var adr1 = this.searchResult[index].ADR1;
      var bunji = this.searchResult[index].BUNJI;
      var nnmb = this.searchResult[index].NNMB;
      var nnmz = this.searchResult[index].NNMZ;
      var bjc = this.searchResult[index].BJC;

      var selectObj = new Object();
      selectObj.zip = zip;
      if (bld != undefined && bld != '' && bld.length > 0) selectObj.nadr1 = nadr1 + ' ' + nadr3 + '(' + bld + ')';
      else selectObj.nadr1 = nadr1 + ' ' + nadr3;
      selectObj.adr1 = adr1 + ' ' + bunji;
      selectObj.nnmb = nnmb;
      selectObj.nnmz = nnmz;
      selectObj.oriNadr1 = nadr1;
      selectObj.oriNadr3 = nadr3;
      selectObj.oriBld = bld + '';
      selectObj.plmkAddrGenMCntn = adr1;
      selectObj.plmkAddrSpecMCntn = bunji;
      selectObj.roadNmAddrGenMCntn = nadr1 + ' ' + nadr3;
      selectObj.ldongCdCntn = bjc;

      this.$emit('callback', selectObj);
    },
  },
};
</script>
